export class View {
    constructor(view) {
        this.view = view;
    }

    open() {
        this.view.open();
    }

    close() {
        this.view.close();
    }

    update() {
        this.view.update();
    }
}